import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { GlobalSettingsService } from 'src/app/_Common/_Services/global-settings.service';

@Injectable({ providedIn: 'root' })
export class IgnosisTransferService {
  dialerBusy$ = new BehaviorSubject<boolean>(false);

  sessionUserId$ = new BehaviorSubject<string>('');

  constructor(private http: HttpClient, private api: GlobalSettingsService) {}

  reportDialerBusy(dialerBusy: boolean) {
    this.dialerBusy$.next(dialerBusy);
    this.http.post<{ userId?: number }>(this.api.getApiUrl() + '/api/ignosis-transfer/presence', { dialerBusy }).subscribe({
      next: (body) => {
        if (body && body.userId) this.sessionUserId$.next(String(body.userId));
      },
      error: () => undefined
    });
  }

  joined(roomName: string) {
    this.http.post(this.api.getApiUrl() + '/api/ignosis-transfer/joined', { roomName }).subscribe({
      error: () => undefined
    });
  }

  release(roomName: string) {
    this.http.post(this.api.getApiUrl() + '/api/ignosis-transfer/release', { roomName }).subscribe({
      error: () => undefined
    });
  }
}
